import * as THREE from 'three';

// ============================================================
// Sky text — floating rules written across the sky
// ============================================================

const TEXT_HEIGHT = 2400;
const LINE_SPACING = 480;

const RULES = [
  'DRONES: Crash into the Aircraft Carrier to score',
  'F-16s: Shoot down the drones to score',
  'Mid-air collision? Drone gets the point!',
  'Stay in the combat zone!',
];

function createTextPlane(text: string): THREE.Mesh {
  const canvas = document.createElement('canvas');
  canvas.width = 4096;
  canvas.height = 256;
  const ctx = canvas.getContext('2d')!;

  ctx.clearRect(0, 0, canvas.width, canvas.height);

  ctx.font = '900 140px Arial, sans-serif';
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';

  // Thick outline
  ctx.strokeStyle = 'rgba(0, 0, 0, 0.6)';
  ctx.lineWidth = 18;
  ctx.strokeText(text, canvas.width / 2, canvas.height / 2);

  // White fill
  ctx.fillStyle = 'rgba(255, 255, 255, 0.9)';
  ctx.fillText(text, canvas.width / 2, canvas.height / 2);

  const texture = new THREE.CanvasTexture(canvas);
  texture.minFilter = THREE.LinearFilter;

  const aspect = canvas.width / canvas.height; // 16:1
  const width = 2400;
  const height = width / aspect;

  const geom = new THREE.PlaneGeometry(width, height);
  const mat = new THREE.MeshBasicMaterial({
    map: texture,
    transparent: true,
    side: THREE.DoubleSide,
    depthTest: false,
    fog: false,
  });

  const mesh = new THREE.Mesh(geom, mat);
  // Rotate to be parallel to the ocean (face downward)
  mesh.rotation.x = Math.PI / 2;
  return mesh;
}

export function createSkyRules(scene: THREE.Scene, centerX: number, centerZ: number): void {
  const totalDepth = (RULES.length - 1) * LINE_SPACING;
  const startZ = centerZ - totalDepth / 2;

  for (let i = 0; i < RULES.length; i++) {
    const mesh = createTextPlane(RULES[i]);
    mesh.position.set(centerX, TEXT_HEIGHT, startZ + i * LINE_SPACING);
    scene.add(mesh);
  }
}
